// extracted by mini-css-extract-plugin
module.exports = {"navBar":"NavBar_navBar__2dwAG","logo":"NavBar_logo__11R0z","nav":"NavBar_nav__2rUdJ","link":"NavBar_link__C28I4","btns":"NavBar_btns__1RKrA","links":"NavBar_links__3x9j5"};